"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Client_1 = __importDefault(require("./Client"));
class ApiOrgChart {
    static getList(token, employeeId) {
        let url = `/orgchart/list`;
        if (employeeId)
            url += `?employeeId=${employeeId}`;
        return Client_1.default.httpGet(url, token);
    }
    static getPhoto(token, id) {
        let url = `/orgchart/photo?id=${id}`;
        return Client_1.default.httpGet(url, token);
    }
}
exports.default = ApiOrgChart;
